import React from "react";

const BottomBar = () => {
  return (
    <div className="w-full bg-gray-200 text-gray-700 py-2 px-4 text-center text-sm shadow-inner">
      © 2025 Super Pets Shop
    </div>
  );
};

export default BottomBar;
